<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="客户名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addClientInfoModal=true">添加客户信息</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div>
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-client-info-modal v-model="addClientInfoModal" @on-success="onSuccess"></add-client-info-modal>
    <client-info-detail-modal v-model="clientInfoDetailModal" :initValue="clientInfoDetailId"
                                @on-success="onModifySuccess"></client-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import AddClientInfoModal from '@/view/components/add-client-info-modal'
import ClientInfoDetailModal from '@/view/components/client-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'clientinfos',
  components: {
    AddClientInfoModal,
    ClientInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 添加客户信息
      addClientInfoModal: false,

      // 客户信息详细信息
      clientInfoDetailModal: false,
      clientInfoDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        clientInfoId: null
      },

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 130
        },
        {
          title: '客户名称',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          width: 150
        },
        {
          title: '联系电话',
          resizable: true,
          key: 'phoneNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '联系地址',
          resizable: true,
          key: 'address',
          ellipsis: 'true',
          width: 370
        },
        {
          title: '关联业务员',
          resizable: true,
          key: 'userId',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            if (params.row.user) {
              return h('div', params.row.user.realName === null ? params.row.user.name : params.row.user.realName)
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 220,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.clientInfoDetailId = params.row.id
                    this.clientInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: params.row.businessNoteId == null ? 'primary' : 'success',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.clientInfoId = params.row.id
                    this.businessNoteInfo.id = params.row.businessNoteId
                    this.businessNoteDetailModal = true
                  }
                }
              }, '业务笔记')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'ClientInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      store.dispatch('ClientInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          p: page,
          ps: 50,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_ClientInfo_GetPageResult) {
        return store.getters.get_ClientInfo_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_ClientInfo_GetPageResult) {
        return store.getters.get_ClientInfo_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_ClientInfo_GetPageResult) {
        return store.getters.get_ClientInfo_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
